module.exports = __webpack_public_path__ + "303b9c3b638ca31f36a2ea297fb9b0f9.fbx";